// @flow

import type {PureAction} from '@travel-frontend/state-handling-sdk';
import type {ProductWithPosition} from 'redux/uiState/priceoverview/PriceoverviewState';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const ADD_PRICEOVERVIEW_PRODUCT =
  'uiState/priceoverview/ADD_PRICEOVERVIEW_PRODUCT';
export const REMOVE_PRICEOVERVIEW_PRODUCT =
  'uiState/priceoverview/REMOVE_PRICEOVERVIEW_PRODUCT';

export function addProduct(p: ProductWithPosition): PureAction {
  return {
    type: PURE(ADD_PRICEOVERVIEW_PRODUCT),
    product: p,
  };
}

export function removeProductWithPosition(p: number): PureAction {
  return {
    type: PURE(REMOVE_PRICEOVERVIEW_PRODUCT),
    position: p,
  };
}
